export function formatImageUploadError(error, operation = 'Bild hochladen') {
  const status = error?.response?.status
  const detail = error?.response?.data?.detail
  let explanation = ''
  if (status === 404) {
    return `${operation} fehlgeschlagen (HTTP 404): Bild oder Assembly ist nicht mehr verfügbar oder nicht für dein Konto freigegeben.`
  }
  if (Array.isArray(detail)) {
    explanation = detail.map(item => {
      const field = Array.isArray(item.loc) ? item.loc.filter(part => part !== 'body').join('.') : ''
      return [field, item.msg].filter(Boolean).join(': ')
    }).filter(Boolean).join('; ')
  } else if (typeof detail === 'string') {
    explanation = detail
  }
  if (!explanation) {
    if (status === 413) explanation = 'Die Datei ist für den Server zu groß.'
    else if (status === 401) explanation = 'Bitte erneut anmelden.'
    else if (status === 403) explanation = 'Keine Berechtigung für diesen Vorgang.'
    else if (status >= 500) explanation = 'Serverfehler. Bitte das API-Protokoll zum Upload-Zeitpunkt prüfen.'
    else if (!error?.response && error?.request) explanation = 'Keine Serverantwort erhalten. Verbindung oder Zeitüberschreitung prüfen.'
    else explanation = 'Der Vorgang konnte nicht abgeschlossen werden.'
  }
  return `${operation} fehlgeschlagen${status ? ` (HTTP ${status})` : ''}: ${explanation}`
}
